export default __webpack_public_path__ + "static/t2-e823463fa40e1859a8574fbd75304141.jpg";